import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

export interface SchedulingLinkSettingsSectionProps {
  sectionSummary?: ReactNode;
  children: ReactNode;
}

/*
 * Style.
 */

const StyledSummaryWrapperDiv = styled.div`
  line-height: 20px;
  margin-bottom: 24px;
`;

/*
 * Component.
 */

export const SchedulingLinkSettingsSection: FC<PropsWithChildren<SchedulingLinkSettingsSectionProps>> = (
  props,
) => (
  <>
    {props.sectionSummary && <StyledSummaryWrapperDiv>{props.sectionSummary}</StyledSummaryWrapperDiv>}
    <div>{props.children}</div>
  </>
);
